import React from 'react';
import Icon from '../../../components/AppIcon';

const PaymentMetrics = ({ paymentRate = 0, avgCollectionTime = 0, loading = false }) => {
  const getPaymentRateColor = (rate) => {
    if (rate >= 80) return { text: 'text-success', bg: 'bg-success/10', icon: 'CheckCircle' };
    if (rate >= 60) return { text: 'text-warning', bg: 'bg-warning/10', icon: 'AlertCircle' };
    return { text: 'text-error', bg: 'bg-error/10', icon: 'XCircle' };
  };

  const getCollectionTimeColor = (days) => {
    if (days <= 15) return { text: 'text-success', bg: 'bg-success/10', icon: 'CheckCircle' };
    if (days <= 30) return { text: 'text-warning', bg: 'bg-warning/10', icon: 'AlertCircle' };
    return { text: 'text-error', bg: 'bg-error/10', icon: 'XCircle' };
  };

  const paymentRateConfig = getPaymentRateColor(paymentRate);
  const collectionTimeConfig = getCollectionTimeColor(avgCollectionTime);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
      {/* Payment Rate */}
      <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
        <div className="flex items-start justify-between mb-3 md:mb-4">
          <div className={`p-2 md:p-3 rounded-lg ${paymentRateConfig?.bg}`}>
            <Icon name="Percent" size={20} className={paymentRateConfig?.text} />
          </div>
          <Icon name={paymentRateConfig?.icon} size={20} className={paymentRateConfig?.text} />
        </div>
        {loading ? (
          <div className="flex justify-center py-4">
            <Icon name="Loader2" className="w-6 h-6 text-blue-600 animate-spin" />
          </div>
        ) : (
          <div className="space-y-1">
            <p className="text-2xl md:text-3xl font-heading font-bold text-foreground data-text">
              {paymentRate?.toFixed(1)}%
            </p>
            <p className="text-xs md:text-sm caption text-muted-foreground">
              Tasa de Pago
            </p>
            <p className="text-xs caption text-muted-foreground">
              Facturas pagadas vs. generadas
            </p>
          </div>
        )}
      </div>

      {/* Average Collection Time */}
      <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
        <div className="flex items-start justify-between mb-3 md:mb-4">
          <div className={`p-2 md:p-3 rounded-lg ${collectionTimeConfig?.bg}`}>
            <Icon name="Clock" size={20} className={collectionTimeConfig?.text} />
          </div>
          <Icon name={collectionTimeConfig?.icon} size={20} className={collectionTimeConfig?.text} />
        </div>
        {loading ? (
          <div className="flex justify-center py-4">
            <Icon name="Loader2" className="w-6 h-6 text-blue-600 animate-spin" />
          </div>
        ) : (
          <div className="space-y-1">
            <p className="text-2xl md:text-3xl font-heading font-bold text-foreground data-text">
              {avgCollectionTime?.toFixed(0)} días
            </p>
            <p className="text-xs md:text-sm caption text-muted-foreground">
              Tiempo Promedio de Cobro
            </p>
            <p className="text-xs caption text-muted-foreground">
              Desde generación hasta pago
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentMetrics;